import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LogIn, AlertCircle } from "lucide-react";
import { Section } from "../components/UIBits";
import { useT } from "../lib/i18n";
import teamApi from "../lib/teamApi";

export default function TeamLoginPage() {
    const { t } = useT();
    const [params] = useSearchParams();
    const nav = useNavigate();
    const [status, setStatus] = useState("checking"); // checking|ok|invalid
    const [err, setErr] = useState("");

    useEffect(() => {
        const token = params.get("token");
        if (!token) {
            setStatus("invalid");
            setErr(t("team_login.missing_token"));
            return;
        }
        localStorage.setItem("du_team_token", token);
        teamApi.get("/team/me")
            .then(() => { setStatus("ok"); setTimeout(() => nav("/equipe"), 600); })
            .catch((e) => {
                localStorage.removeItem("du_team_token");
                setStatus("invalid");
                setErr(e?.response?.data?.detail || t("team_login.invalid_token"));
            });
    }, [params, nav, t]);

    return (
        <div data-testid="team-login-page">
            <Helmet><title>{`${t("team_login.title")} — Défi Ultime`}</title></Helmet>
            <Section>
                <div className="max-w-lg mx-auto glass-card p-8 border-t-4 border-[#7FD93C]">
                    <LogIn size={40} className="text-[#7FD93C] mx-auto mb-4" />
                    <h1 className="font-display text-3xl uppercase tracking-widest text-center mb-2">{t("team_login.title")}</h1>
                    {status === "checking" && <p className="text-center text-white/60 mt-4">{t("common.loading")}</p>}
                    {status === "ok" && <p className="text-center text-[#7FD93C] mt-4">{t("team_login.welcome")}</p>}
                    {status === "invalid" && (
                        <div className="mt-6">
                            <div className="flex items-start gap-3 bg-rose-500/10 border-l-2 border-rose-500 p-4">
                                <AlertCircle className="text-rose-400 flex-shrink-0 mt-0.5" size={18} />
                                <div className="text-sm">
                                    <div className="font-semibold text-rose-300 mb-1">{t("team_login.error_label")}</div>
                                    <div className="text-white/70">{err}</div>
                                </div>
                            </div>
                            <Link to="/contact" className="btn-outline mt-6 w-full justify-center">{t("team_login.contact_admin")}</Link>
                        </div>
                    )}
                </div>
            </Section>
        </div>
    );
}
